import { connect } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';
import { compose, mapProps, withHandlers } from 'recompose';
import reject from 'ramda/src/reject';
import contains from 'ramda/src/contains';
import { t } from '../../../../modules/infra/i18n';
import ReportsFilter from '../reportsFilter';
import {
  updateBrandFilter,
  brandFilterDeselectAll,
  brandFilterSelectAll,
} from '../actions';
import {
  getActiveBrandIds,
  getBrandFilters,
  getBrandFiltersAllChecked,
} from '../selectors';
import fetchBrandData from './fetchBrandFilterData';

const BrandFilterContainer = ({ updateFilter, filters, allChecked, title }) => (
  <div>
    <ReportsFilter
      title={title}
      filters={filters}
      updateStatusViewed={updateFilter}
      allChecked={allChecked}
      showSelectAll
    />
  </div>
);

BrandFilterContainer.propTypes = {
  updateFilter: PropTypes.func.isRequired,
  filters: PropTypes.array.isRequired,
  removeFilters: PropTypes.array,
  allChecked: PropTypes.bool,
  title: PropTypes.string.isRequired,
};

BrandFilterContainer.defaultProps = {
  removeFilters: [],
  allChecked: false,
};

const mapStateToProps = state => ({
  filters: getBrandFilters(state),
  allChecked: getBrandFiltersAllChecked(state),
  title: `${t('reports:filters.brand.title')} ${
    getBrandFiltersAllChecked(state) ? t('reports:filters.brand.all') : `(${getActiveBrandIds(state).length})`
  }`,
});

const mapDispatchToProps = {
  updateBrandFilter,
  brandFilterDeselectAll,
  brandFilterSelectAll,
};

const removeFilters = mapProps(props => ({
  ...props,
  filters: reject(item => contains(item.title, props.removeFilters || []), props.filters),
}));

const handlers = withHandlers({
  updateFilter: props => (data) => {
    if (data === true) {
      return props.brandFilterSelectAll();
    }

    if (data === false) {
      return props.brandFilterDeselectAll();
    }

    return props.updateBrandFilter(data);
  },
});

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  removeFilters,
  handlers,
  fetchBrandData,
);

export default enhance(BrandFilterContainer);
